import { render, staticRenderFns } from "./stadium-service-config.vue?vue&type=template&id=969edbd4&scoped=true&"
import script from "./stadium-service-config.vue?vue&type=script&lang=js&"
export * from "./stadium-service-config.vue?vue&type=script&lang=js&"
import style0 from "./stadium-service-config.vue?vue&type=style&index=0&id=969edbd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969edbd4",
  null
  
)

export default component.exports